import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './HistoryPage.css';
import momiboLogo from '../assets/momibo03-momibo.png';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function HistoryPage() {
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadHistory();
  }, []);

  const loadHistory = async () => {
    try {
      const response = await axios.get(`${API_URL}/history`);
      setHistory(response.data.history);
    } catch (error) {
      console.error('履歴の読み込みエラー:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (historyId) => {
    if (!window.confirm('この会話履歴を削除しますか？')) return;

    try {
      await axios.delete(`${API_URL}/history/${historyId}`);
      setHistory(history.filter(item => item.id !== historyId));
    } catch (error) {
      console.error('削除エラー:', error);
      alert('削除に失敗しました');
    }
  };

  return (
    <div className="history-page">
      <header className="history-header" style={{ backgroundImage: `url(${momiboLogo})` }}>
        <button className="home-btn" onClick={() => navigate('/')}>
          🏠
        </button>
      </header>

      <div className="history-container">
        <div className="title-box">
          <div className="commissioner-title-text">会話履歴</div>
        </div>

        <div className="history-content">
          {loading ? (
            <div className="loading-message">読み込み中...</div>
          ) : history.length === 0 ? (
            <div className="empty-message">
              <p>まだ会話履歴がありません</p>
              <button onClick={() => navigate('/chat')} className="start-chat-btn">
                チャットを始める
              </button>
            </div>
          ) : (
            <div className="history-list">
              {history.map((item) => (
                <div key={item.id} className="history-card">
                  <div className="history-header-row">
                    <div className="history-date">
                      {new Date(item.created_at).toLocaleString('ja-JP')}
                    </div>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(item.id)}
                      title="削除"
                    >
                      🗑️
                    </button>
                  </div>
                  <div className="history-qa">
                    <div className="history-q">
                      <div className="q-label">質問</div>
                      <div className="q-content">{item.question}</div>
                    </div>
                    <div className="history-a">
                      <div className="a-label">回答</div>
                      <div className="a-content">{item.answer}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HistoryPage;
